import { Controller } from "stimulus"
import toastr from "toastr/toastr"

let showFlashListeberAdded = false
toastr.options = {
  timeOut: 5000,
  extendedTimeOut: 5000,
  newestOnTop: true,
  progressBar: true,
  tapToDismiss: false,
  toastClass: 'toast toast-showing',
  titleClass: 'toast-header',
  messageClass: 'toast-body',
  closeButton: true,
  closeHtml: `
    <button class="close" type="button" aria-label="Close">
      <small><i class="fas fa-times" aria-hidden="true"></i></small>
    </button>
  `
}

toastr.options.onHidden = function () {
  $('.toast-wrapper:empty').animate(
    { height: 0 },
    toastr.options.closeDuration,
    toastr.options.closeEasing,
    function () {
      this.remove()
    }
  )
}

toastr.options.onCloseClick = function ({ currentTarget }) {
  const $wrapper = $(currentTarget).parents('.toast-wrapper')

  $wrapper.animate(
    { height: 0 },
    toastr.options.closeDuration,
    toastr.options.closeEasing
  )
}

export default class extends Controller {
  connect() {
    const { role, message } = this.element.dataset || {}

    if (message) {
      this.showFlashMessage(role, message)
    }

    if (!showFlashListeberAdded) {
      showFlashListeberAdded = true
      document.addEventListener('show-flash', (event) => {
        this.showFlashMessage(event.detail.role, event.detail.message)
      })
    }
  }

  showFlashMessage(role, message) {
    const isError = role === 'error'
    const header = `
      ${isError
        ? '<big><i class="fas fa-exclamation-triangle highlight-red mr-2"></i></big>'
        : '<big><i class="fas fa-check-circle highlight-green mr-2"></i></big>'
      }
      <strong>
        ${isError
        ? 'Error'
        : 'Success'
      }
      </strong>
    `
    toastr[isError ? 'error' : 'success'](message, header)

    const $toast = $('#toast-container > .toast:first-child')

    $toast.wrap('<div class="toast-wrapper"></div>')

    const $wrapper = $toast.parent()
    const height = $toast.outerHeight() + parseInt($toast.css('marginBottom'))

    $wrapper.css('height', 0)
    $wrapper.animate(
      { height },
      toastr.options.showDuration,
      toastr.options.showEasing
    )
  }
}
